import { Injectable } from '@angular/core';

import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';

@Injectable()
export class CancelTranscService {

	constructor(
		private requestService: CommonRequestService
	) { }

	// Tell backend to cancel the process
	// The successCallback doesn't mean the process is canceled successfully, only backend gets the cancel request successfully.
	cancelTransc(processId: string, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'common/cancelProcess';
		const body = {
				processId: processId
		};
		this.requestService.requestPost(url, body, successCallback, errorCallback);
	}

}
